import { useState } from 'react'
import { Paragraph, useEvent, View } from 'tamagui'
import * as Stores from '../stores'
import { Button } from '@/src/common/components/Button'
import { formatCurrency } from '@/src/common/utils/general'
import { Input } from '@/src/common/components/Input'
export function ProgramUnenrolled() {
  const { data: awardQueryResult } = Stores.MortgageEarnApi.endpoints[
    'GET /mortgage/earn'
  ].useQuery({})
  const [updateAmount] = Stores.MortgageEarnApi.endpoints['POST /mortgage/earn'].useMutation()

  const { latestMonthlyAward } = awardQueryResult ?? {}
  const { awardAmountInPoints: latestAwardAmount } = latestMonthlyAward ?? {}

  const [updateValue, setUpdateValue] = useState(latestAwardAmount ?? 0)

  const handleChangeText = useEvent((value: string) => {
    const numericValue = value.replace(/[^0-9]/g, '')
    setUpdateValue(numericValue ? Number(numericValue) : 0)
  })

  const handleUpdateMonthlyHousingPayment = useEvent((amount: number) => {
    void updateAmount({
      body: {
        monthlyAward: amount,
      },
    })
  })
  return (
    <>
      <Paragraph>
        You are not enrolled in the Mesa Home program. Please update your mortgage amount to enroll.
      </Paragraph>

      <View gap={16}>
        <Input
          keyboardType="numeric"
          label="Monthly housing payment"
          value={
            updateValue === 0
              ? ''
              : formatCurrency(updateValue, {
                  decimals: 0,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
          }
          onChangeText={handleChangeText}
        />
        <Button
          title="Set Mortgage Amount"
          segmentAction="MesaHome MortgagePayment SubmitUpdatedMonthlyHousingPaymentNotEnrolled"
          onPress={() => handleUpdateMonthlyHousingPayment(updateValue)}
        />
      </View>
    </>
  )
}
